import shape from "../../assets/img/shapes/pencil-shape-02.webp";


const PencilShape02 = () => {

    return (
        <div className="rmdr-pencil-shape-02">
            <img src={shape} alt="rmdr-pencil-shape-02" loading="lazy" width={80} height={80} />
        </div>
    )

}

export default PencilShape02;
